export const NAMESPACE = "NewPortalHome";

export const SECTIONS_IDS = {
  HOME: "home",
  SESSIONS: "sessions",
  PROFILE: "profile",
  HISTORY: "history",
  TASKS: "tasks",
  FILES: "files",
  RESOURCES: "resources",
  APPLICATIONS: "applications",
  CALENDAR: "calendar",
  MESSAGES: "messages"
};

export const SECTIONS_MENU = [
  {
    id: SECTIONS_IDS.HOME,
    name: "Home",
    icon: "home",
    color: "#FFFFFF"
  },
  {
    id: SECTIONS_IDS.SESSIONS,
    name: "Sessions",
    icon: "calendar_month",
    color: "#FFFFFF"
  },
  {
    id: SECTIONS_IDS.PROFILE,
    name: "Profile",
    icon: "account_circle",
    color: "#FFFFFF"
  },
  /*
  {
    id: SECTIONS_IDS.HISTORY,
    name: "History & Connections",
    icon: "history_edu",
    color: "#FFFFFF"
  },
  */
  {
    id: SECTIONS_IDS.TASKS,
    name: "Tasks",
    icon: "work_outline",
    color: "#FFFFFF",
    shouldScrollToSection: true
  },
  {
    id: SECTIONS_IDS.FILES,
    name: "Files",
    icon: "assignment",
    color: "#FFFFFF",
    shouldScrollToSection: true
  },
  {
    id: SECTIONS_IDS.RESOURCES,
    name: "Resources",
    icon: "pages",
    color: "#FFFFFF",
    shouldScrollToSection: true
  }
  // {
  //   id: SECTIONS_IDS.CALENDAR,
  //   name: "Calendar",
  //   icon: "calendar_today",
  //   color: "#FFFFFF"
  // }
  /*
  {
    id: SECTIONS_IDS.MESSAGES,
    name: "Messages",
    icon: "mail",
    color: "#FFFFFF"
  }
    */
];

export const MOCK_WIKI_PAGES = [
  {
    id: 1,
    image:
      "https://cdn.prod.website-files.com/627d5c68d5739644034cfd28/6565804dd006b23a39994565_sessionboard-flywheel.jpg",
    title: "Conference Wiki FAQ",
    text: "Get answers to commonly-asked questions here!"
  },
  {
    id: 2,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ80sJepvo_9pZb_W40yO4tv_Hp93qTvwUyNw&s",
    title: "Conference Wiki MAP",
    text: "Get answers to commonly-asked questions here!"
  },
  {
    id: 3,
    image:
      "https://cdn.prod.website-files.com/627d5c68d5739644034cfd28/6284bde1e849fa104e349288_sessionboard-preview.png",
    title: "How to visualize your data",
    text: "Get answers to commonly-asked questions here!"
  },
  {
    id: 3,
    image:
      "https://cdn.prod.website-files.com/627d5c68d5739644034cfd28/6565804dd006b23a39994565_sessionboard-flywheel.jpg",
    title: "How to visualize your data",
    text: "Get answers to commonly-asked questions here!"
  }
];

export const MOCK_QUICK_LINKS = [
  {
    id: 1,
    url: "/",
    text: "Tickets",
    icon: "material-icons,local_activity",
    color: "#DA8B4F"
  },
  {
    id: 2,
    url: "/",
    text: "Hotel",
    icon: "material-icons,home",
    color: "#8156BE"
  },
  {
    id: 3,
    url: "/",
    text: "Location 1",
    icon: "material-icons,location_on",
    color: "#CB5F51"
  },
  {
    id: 4,
    url: "/",
    text: "Location 2",
    icon: "material-icons,location_on",
    color: "#CB5F51"
  },
  {
    id: 4,
    url: "/",
    text: "Location 2",
    icon: "material-icons,location_on",
    color: "#CB5F51"
  }
];
